// extracted by mini-css-extract-plugin
export default {"additional-details-container":"vswxBz+PBjAKLZMGhWP7Ow==","mobile":"R99Z8RuxFbOTyPlecDPRRw=="};